const fieldToValidate = [
  'Name',
  'Description',
  'MenuType',
  'MenuClass',
  'MenuCategory',
];
const fieldToValidatePrice = ['MinPax', 'Cost', 'Currency'];
export { fieldToValidate, fieldToValidatePrice };
